import { lazy } from "react";
import AppIcons from "../../../components/Base/AppIcons/AppIcons";

const RecaudoVeolia = lazy(() => import("./views/RecaudoVeolia"));

const rutasVeolia = {
  link: "/Veolia",
  label: <AppIcons Logo={"RECAUDO"} name="Recaudo Veolia" />,
  component: RecaudoVeolia,
  permission: [27030],
  subRoutes: [],
};

export default rutasVeolia;
